<template>
  <div v-if="$slots['relation-cell']">
    <template-item layout="flex" :label="label" class="v-center">
      <slot name="biz-type" />
    </template-item>
    <template-item layout="flex" label="关联列" class="v-center">
      <div class="flex flex-row v-center">
        <div class="flex-fill" style="overflow: hidden;">
          <slot name="relation-cell" />
        </div>
        <div class="flex-auto">
          <slot name="action" />
        </div>
      </div>
    </template-item>
  </div>
  <template-item v-else layout="flex" :label="label" class="v-center">
    <div class="flex flex-row v-center">
      <div class="flex-fill" style="overflow: hidden;">
        <slot name="biz-type" />
      </div>
      <div class="flex-auto">
        <slot name="action" />
      </div>
    </div>
  </template-item>
</template>
<script>
import TemplateItem from "@/components/excel/designer/template/TemplateItem";
export default {
  components: { TemplateItem },
  props: {
    label: {
      type: String,
      default: "业务类型",
    },
  },
};
</script>
